<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { loadStripeConnect, stripeSessionError } from '@/lib/stripeConnect'

const props = defineProps<{
  component: 'account-onboarding' | 'notification-banner'
  stripeKey: string
}>()

const emit = defineEmits<{ exit: [] }>()

const container = ref<HTMLElement | null>(null)
const error = ref('')

// The server's message when it gave one, as it says what Stripe refused.
function fail() {
  error.value = stripeSessionError() ?? "Stripe's form could not be loaded. Please refresh the page and try again."
}

onMounted(async () => {
  try {
    const instance = await loadStripeConnect(props.stripeKey)
    const element = instance.create(props.component)

    element.setOnLoadError(fail)
    if (props.component === 'account-onboarding') {
      element.setOnExit(() => emit('exit'))
    }
    container.value?.appendChild(element)
  } catch {
    fail()
  }
})
</script>

<template>
  <div>
    <div ref="container" />
    <p v-if="error" class="rounded-lg bg-red-50 p-3 text-sm text-red-800">{{ error }}</p>
  </div>
</template>
